class PdpClonedCta extends HTMLElement {
  constructor() {
    super();

    this.EXCLUDED_PARENTS = [
      'po-monogram-alert-drawer',
      '.modal-paying-instalments-container'
    ];
  }

  connectedCallback() {
    this.sourceContainerId = this.dataset.sourceContainerId;
    this.sourceContainer = document.querySelector(
      `#${this.sourceContainerId}`
    );

    if (!this.sourceContainer) return;

    this.init();
  }

  init() {
    const ignoreRxc = this.hasAttribute('data-ignore-rxc');

    this.formButtonToClone = Array.from(
      this.sourceContainer.querySelectorAll(
        '.js-pdp-po-main-buy-buttons button'
      )
    ).filter(button => {
      if (button.closest(this.EXCLUDED_PARENTS.join(','))) return false;
      if (ignoreRxc && button.name === 'rxc-activator') return false;
      return true;
    });

    // Monogram alert reference
    this.poMonogramAlertVisible = document.querySelector(
      'po-monogram-alert-drawer'
    );
    this.alertMonogramBtn = document.querySelector(
      '[data-alert-monogram-with-rxc]'
    );

    this.formButtonToClone.forEach(originalButton => {
      this.handleCloningCta(originalButton);
    });
  }

  handleCloningCta(originalButton) {
    const clonedButton = originalButton.cloneNode(true);
    clonedButton.removeAttribute('id');
    clonedButton.dataset.cloned = 'true';

    if (originalButton.dataset.elementId === 'Prod_AddCart') {
      clonedButton.dataset.elementId = 'Stickybar_AddCart';
    }

    this.appendChild(clonedButton);

    // Salviamo riferimento SOLO nel clone
    clonedButton.__pdpOriginal = originalButton;

    this.setupObserver(originalButton, clonedButton);

    clonedButton.addEventListener('click', e => {
      e.preventDefault();

      if (
        e.currentTarget.name === 'rxc-activator' &&
        this.isMonogramAlertCoveringCta()
      ) {
        this.alertMonogramBtn?.click();
        return;
      }

      originalButton.click();
    });
  }

  setupObserver(originalButton, clonedButton) {
    // Se non esiste ancora struttura sul bottone
    if (!originalButton.__pdp) {
      const clones = new Set();

      const observer = new MutationObserver(mutations => {
        clones.forEach(clone => {
          mutations.forEach(mutation => {
            if (mutation.type === 'attributes') {
              this.syncAttributes(
                originalButton,
                clone,
                mutation.attributeName
              );
            }

            if (mutation.type === 'childList') {
              this.syncInnerContent(originalButton, clone);
            }
          });
        });
      });

      observer.observe(originalButton, {
        attributes: true,
        childList: true,
        subtree: true
      });

      originalButton.__pdp = {
        observer,
        clones
      };
    }

    originalButton.__pdp.clones.add(clonedButton);
  }

  syncAttributes(original, clone, attrName) {
    if (attrName === 'class') {
      clone.className = original.className;
    } else if (attrName === 'style') {
      clone.setAttribute('style', original.getAttribute('style'));

      const displayValue = original.style.getPropertyValue('display');
      if (displayValue) {
        clone.style.setProperty('display', displayValue, '');
      }
    } else {
      if (original.hasAttribute(attrName)) {
        clone.setAttribute(attrName, original.getAttribute(attrName));
      } else {
        clone.removeAttribute(attrName);
      }
    }
  }

  syncInnerContent(original, clone) {
    clone.innerHTML = original.innerHTML;
  }

  isMonogramAlertCoveringCta() {
    if (!this.poMonogramAlertVisible || !this.alertMonogramBtn) {
      return false;
    }

    return !this.poMonogramAlertVisible.hasAttribute('hidden');
  }

  disconnectedCallback() {
    this.querySelectorAll('[data-cloned="true"]').forEach(clone => {
      const original = clone.__pdpOriginal;
      if (!original?.__pdp) return;

      original.__pdp.clones.delete(clone);

      if (original.__pdp.clones.size === 0) {
        original.__pdp.observer.disconnect();
        delete original.__pdp;
      }
    });
  }
}

// Register base element
if (!customElements.get('pdp-cloned-cta')) {
  customElements.define('pdp-cloned-cta', PdpClonedCta);
}